import { dashboardFiltersStore } from "../stores/filters.store";
import { dashboardKpiStore } from "../stores/kpi.store";
import { dashboardOverviewStore } from "../stores/target-data-overview.store";
import { dashboardMetricDetailStore } from "../stores/metric-detail.store";
import { dashboardOrgDetailStore } from "../stores/org-detail.store";
import { dashboardConsolidatedMetricOverviewStore } from "../stores/consolidated-metric-overview.store";
import { dashboardConsolidatedMetricDetailStore } from "../stores/consolidated-metric-detail.store";
import { dashboardConsolidatedOrgDetailStore } from "../stores/consolidated-org-detail.store";
import { dashboardEsgDataTableStore } from "../stores/esg-data-table.store";
import { dashboardEmissionsBreakdownStore } from "../stores/emissions-breakdown.store";

export const useDashboardFiltersStore = () => dashboardFiltersStore;
export const useDashboardKpiStore = () => dashboardKpiStore;
export const useDashboardOverviewStore = () => dashboardOverviewStore;
export const useDashboardMetricDetailStore = () => dashboardMetricDetailStore;
export const useDashboardOrgDetailStore = () => dashboardOrgDetailStore;
export const useDashboardConsolidatedMetricOverviewStore = () =>
  dashboardConsolidatedMetricOverviewStore;
export const useDashboardConsolidatedMetricDetailStore = () =>
  dashboardConsolidatedMetricDetailStore;
export const useDashboardConsolidatedOrgDetailStore = () =>
  dashboardConsolidatedOrgDetailStore;
export const useDashboardEsgDataTableStore = () => dashboardEsgDataTableStore;
export const useDashboardEmissionsBreakdownStore = () =>
  dashboardEmissionsBreakdownStore;
